import { z } from "zod"

export const signInSchema = z.object({
  email: z.string().email({
    message: "Invalid email address",
  }),
})

// Payload of the login-code request: the email plus the bot-trap fields the
// backend requires (see nango/authentication/auth/serializers.py).
export const requestLoginCodeSchema = signInSchema.extend({
  company_website: z.string(),
  elapsed_ms: z.number(),
  email_prefilled: z.boolean(),
})

export const provideCodeSchema = z.object({
  code: z.string(),
})

export const emailWithCodeSchema = z.object({
  email: z.string().email({
    message: "Invalid email address",
  }),
  code: z.string(),
})
